var _g, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_2_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.82 268.71"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167 72.13a7 7 0 00-1.2-.66 6.87 6.87 0 00-2.76-.55 7.53 7.53 0 00-2.11.31 7.75 7.75 0 00-.94.39 5.93 5.93 0 00-.56.29 7.08 7.08 0 00-3.52 6.09v163h14.17V78a7.06 7.06 0 00-.56-2.76 7.37 7.37 0 00-1.06-1.74 6.79 6.79 0 00-1.46-1.37zM141.79 78a7.07 7.07 0 00-7.1-7.08 6.87 6.87 0 00-2.76.55 7.1 7.1 0 00-1.21.66 7 7 0 00-1.5 1.37 6.6 6.6 0 00-1.06 1.74 7.06 7.06 0 00-.56 2.76v148.77h14.19z",
    transform: "translate(-77.06 -42.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 26.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.3 99.17a4.68 4.68 0 00.53 0A7.09 7.09 0 00106.3 85a14.18 14.18 0 010-28.35H248A14.18 14.18 0 01248 85a7.11 7.11 0 000 14.21h1.07A28.35 28.35 0 00248 42.48H105.24a28.35 28.35 0 101.06 56.69z",
    transform: "translate(-77.06 -42.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.43 78a7.06 7.06 0 00-.56-2.76 7.37 7.37 0 00-1.06-1.74 7.1 7.1 0 00-8.23-2 7 7 0 00-1.2.66 6.79 6.79 0 00-1.51 1.37 7.37 7.37 0 00-1.06 1.74 7.06 7.06 0 00-.56 2.76v148.79h14.18zM221.79 71.23a7.19 7.19 0 00-2.11-.31 7 7 0 00-5.46 2.58 6.6 6.6 0 00-1.06 1.74 7.06 7.06 0 00-.56 2.76v163h14.17V78a7.09 7.09 0 00-4.98-6.77z",
    transform: "translate(-77.06 -42.47)"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  })));
}
export default SvgLogo2;